// Maps the robot's `network_state` telemetry field to a display label.
// Values sent by the robot firmware (see frodobots-raspberrypi ec2x.cc CheckState):
//   0 = no network, 1 = cellular only (4G), 2 = wifi only, 3 = both wifi + cellular
// Older firmware does not send `network_state` at all (undefined) — fall back to "4G"
// to preserve the previous hardcoded behavior.
export const getNetworkLabel = (networkState) => {
  switch (networkState) {
    case 0:
      return 'No Signal';
    case 1:
      return '4G';
    case 2:
      return 'WiFi';
    case 3:
      return 'WiFi';
    default:
      return '4G';
  }
};
